var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "add-review-form",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmit($event)
        }
      }
    },
    [
      _c("div", { staticClass: "add-review-form__header" }, [
        _c(
          "button",
          {
            staticClass: "close",
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.closeForm($event)
              }
            }
          },
          [
            _c("svg", { attrs: { width: "24", height: "24" } }, [
              _c("use", { attrs: { "xlink:href": "/sprite.svg#icon-close" } })
            ])
          ]
        ),
        _vm._v(" "),
        _c("h5", { staticClass: "add-review-form__title" }, [
          _vm._v("Новый отзыв")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "add-review-form__row" }, [
        _c("div", { staticClass: "add-review-form__label" }, [
          _vm._v("Ваша оценка")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "add-review-form__rating" },
          [
            _c("rating-input", {
              on: {
                input: function($event) {
                  _vm.error = !_vm.reviewRating
                }
              },
              model: {
                value: _vm.reviewRating,
                callback: function($$v) {
                  _vm.reviewRating = $$v
                },
                expression: "reviewRating"
              }
            }),
            _vm._v(" "),
            _vm.error
              ? _c("div", { staticClass: "add-review-form__error" }, [
                  _vm._v("\n               Укажите оценку\n            ")
                ])
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "add-review-form__row" }, [
        _c("div", { staticClass: "add-review-form__label" }, [_vm._v("Отзыв")]),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.reviewText,
              expression: "reviewText"
            }
          ],
          staticClass:
            "add-review-form__input add-review-form__input--textarea",
          domProps: { value: _vm.reviewText },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.reviewText = $event.target.value
            }
          }
        })
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.isLoading
          ? _c("div", { staticClass: "add-review-form__spinner" }, [
              _c("div", {
                staticClass: "spinner-border text-main",
                attrs: { role: "status" }
              })
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "add-review-form__btn" }, [
      _c("button", { staticClass: "btn btn-outline-main btn-block" }, [
        _vm._v("Оставить отзыв")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }